<template>
  <div class="col-12 widget-title mb-4">
    {{ widgetName }}
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { StringMap } from '@/types';

export default defineComponent({
  name: 'StatsWidgetTitle',

  props: {
    name: {
      type: [String, Object] as PropType<string | StringMap>,
      required: true,
    },
  },

  setup(props: { name: string | StringMap }) {
    const { locale } = useI18n();

    const widgetName = computed(() => (typeof props.name === 'string'
      ? props.name
      : (props.name?.[locale.value] ?? '')));

    return {
      widgetName,
    };
  },
});
</script>

<style scoped lang="scss">
.widget-title {
  font-size: 1.2rem;
  line-height: 1.2rem;
  border-bottom: solid 1px $solitude;
  padding: 15px 10px;
}
</style>
